import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useSiteContent } from "@/hooks/useSiteContent";
import { optimizedImage } from "@/lib/img";

interface Item { id: string; image_url: string; caption: string | null; }

export function Gallery() {
  const { content } = useSiteContent();
  const [items, setItems] = useState<Item[]>([]);

  useEffect(() => {
    supabase.from("gallery").select("id,image_url,caption").eq("visible", true).order("sort_order").then(({ data }) => {
      setItems((data as Item[]) || []);
    });
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="gallery" className="py-16 md:py-20 bg-muted/30">
      <div className="container">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="text-3xl md:text-4xl">{content.gallery_title}</h2>
          <p className="mt-3 text-muted-foreground">{content.gallery_subtitle}</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => (
            <figure key={it.id} className="group overflow-hidden rounded-2xl ring-1 ring-border bg-card shadow-elegant">
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={optimizedImage(it.image_url, 800)}
                  srcSet={`${optimizedImage(it.image_url, 400)} 400w, ${optimizedImage(it.image_url, 800)} 800w, ${optimizedImage(it.image_url, 1200)} 1200w`}
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  alt={it.caption || "Work photo"} loading="lazy" decoding="async" width={800} height={600}
                  className="h-full w-full object-cover transition-smooth group-hover:scale-105" />
              </div>
              {it.caption && <figcaption className="p-3 text-sm font-medium">{it.caption}</figcaption>}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Gallery;
